import type { schemaType } from '~~/modules/api/strapi/vacaciones-landings/detail/schema'
import type { propsInterface } from '~~/modules/design-system/sections/s-hero-card-search.vue'

export const useToSHeroCardSearch = () => {
  const fromStrapiHolidaysDetail = (data: schemaType): propsInterface => {
    const filteredData = {
      image: data.attributes.img?.data?.attributes.url as string,
      title: t('landings.holidays.hero.title'),
      name: data.attributes.name,
      location: data.attributes.slug,
    }
    return filteredData
  }

  return { fromStrapiHolidaysDetail }
}
